/* The browsing panel: a side panel on desktop, a bottom sheet on touch. */

/* A real button, so dismissing by tapping away is keyboard-reachable. */
.scrim {
  position: fixed;
  cursor: default;
  visibility: hidden;
  inset: 0;
  z-index: 40;
  background: rgba(12, 34, 25, 0.07);
  -webkit-backdrop-filter: blur(1px);
  backdrop-filter: blur(1px);
  opacity: 0;
  transition:
    opacity 0.42s var(--ease),
    visibility 0s linear 0.42s;
  pointer-events: none;
}

.scrim.scrimShown {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transition:
    opacity 0.42s var(--ease),
    visibility 0s;
}

.sheet {
  position: fixed;
  z-index: 50;
  display: flex;
  flex-direction: column;
  right: calc(14px + var(--safe-r));
  top: calc(72px + var(--safe-t));
  bottom: calc(14px + var(--safe-b));
  width: 392px;
  border-radius: var(--r-lg);
  transform: translateX(calc(100% + 30px));
  opacity: 0;
  transition:
    transform 0.52s var(--ease),
    opacity 0.3s var(--ease),
    visibility 0s linear 0.52s;
  overflow: hidden;
  visibility: hidden;
}

.sheet.shown {
  transform: none;
  opacity: 1;
  visibility: visible;
  transition:
    transform 0.52s var(--ease),
    opacity 0.3s var(--ease),
    visibility 0s;
}

.grip {
  display: none;
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 14px 10px 20px;
  flex: none;
}

.head h2 {
  margin: 0;
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.body {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding: 4px 10px calc(18px + var(--safe-b));
  touch-action: pan-y;
}

.body::-webkit-scrollbar {
  width: 7px;
}

.body::-webkit-scrollbar-thumb {
  background: rgba(11, 31, 23, 0.14);
  border-radius: 999px;
}

.section {
  margin: 10px 6px 6px;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--ink-3);
}

@media (max-width: 900px) {
  .scrim {
    background: rgba(12, 34, 25, 0.18);
    -webkit-backdrop-filter: blur(3px);
    backdrop-filter: blur(3px);
  }

  .sheet {
    left: 0;
    right: 0;
    bottom: 0;
    top: auto;
    width: 100%;
    height: min(84vh, 760px);
    border-radius: var(--r-xl) var(--r-xl) 0 0;
    transform: translateY(100%);
  }

  .grip {
    display: grid;
    place-items: center;
    padding: 9px 0 3px;
    flex: none;
    touch-action: none;
    cursor: grab;
  }

  .grip span {
    width: 38px;
    height: 5px;
    border-radius: 999px;
    background: rgba(11, 31, 23, 0.16);
    display: block;
  }

  .head {
    padding-top: 6px;
  }

  .body {
    padding-bottom: calc(28px + var(--safe-b));
  }
}
